import { ActivatedRoute } from '@angular/router';

import { AuthService } from '../../auth/auth.service';
import { ChatContext } from '../../coaching-base/chat-context.model';
import { Command } from '../../coaching-base/command/command';
import { ChatDialogData } from '../../coaching/detail/teamschat-dialog/model/chat-dialog-data.model';
import { epicDependencies } from '../../store';
import { ChatMenuDialogService } from '../../teams-call/chat-menu/dialog/chat-menu-dialog.service';
import { ChatNav } from '../../teams-call/chat-menu/dialog/model/chat-nav.model';

/* TODO rename */
export function overrideCommitment(): void {
    try {
        // TODO FIXME. this can be done better
        const service =
            epicDependencies.injector.get<ActivatedRoute>(
                ActivatedRoute,
            ).snapshot;

        const commandB64 = service.queryParamMap.get('coachingCommand');
        const params = new URLSearchParams(atob(commandB64));
        const commandStr = params.get('command');

        switch (commandStr.toLowerCase()) {
            case Command.OPEN_CHAT.toLowerCase():
                openChat(params);
                break;
        }
    } catch {}
}

export function openChat(params: URLSearchParams): void {
    // TODO FIXME. this can be done better
    const service = epicDependencies.injector.get<ChatMenuDialogService>(
        ChatMenuDialogService,
    );
    const authService = epicDependencies.injector.get<AuthService>(AuthService);

    const commitmentId = parseInt(params.get('commitmentId'));
    const behaviourId = parseInt(params.get('behaviourId'));
    const subBehaviourId = parseInt(params.get('subBehaviourId'));
    const performerId = parseInt(params.get('performerId'));

    const ctx: ChatContext = {
        commitmentId,
        behaviourId,
        subBehaviourId,
        coachId: authService.user.id /* TODO revise for hierarchy changes */,
        performerId,
    };

    const cbd: ChatDialogData = {
        chatRequest: {
            members: [ctx.coachId, ctx.performerId] /* TODO revise */,
            context: JSON.stringify(ctx),
        },
    };

    service.open(ChatNav.CHAT_BOX, {
        chatBoxData: cbd,
    });
}
